import { QueryStatus } from '@reduxjs/toolkit/query';
import React from 'react';

export const useUpdater = (
  update: (value: string) => Promise<void>,
  initialValue: string,
): [(value: string) => void, QueryStatus] => {
  const [status, setStatus] = React.useState<QueryStatus>(QueryStatus.uninitialized);

  const updateWrapper = React.useCallback(
    async (value: string): Promise<void> => {
      if (value === initialValue) {
        // No change happened, so ignore
        return;
      }

      setStatus(QueryStatus.pending);
      try {
        await update(value);
        setStatus(QueryStatus.fulfilled);
      } catch (error: unknown) {
        void error;
        setStatus(QueryStatus.rejected);
      }
    },
    [initialValue, update],
  );

  return [updateWrapper, status];
};
